import { render, staticRenderFns } from "./CashRegister.vue?vue&type=template&id=0dca1881&scoped=true&"
import script from "./CashRegister.vue?vue&type=script&lang=js&"
export * from "./CashRegister.vue?vue&type=script&lang=js&"
import style0 from "./CashRegister.vue?vue&type=style&index=0&id=0dca1881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca1881",
  null
  
)

export default component.exports